module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-farbe-beispiel-weiss.1afc5c94.jpeg";